import { AxiosInstance } from 'axios';

import { ORGANISATION_KEY, OrganisationContextData } from '../../utils/context/OrganisationContext';

export const organisationInterceptor = (client: AxiosInstance) => {
  client.interceptors.request.use(
    (conf) => {
      try {
        const item = window.localStorage.getItem(ORGANISATION_KEY) as any;
        const checkUrl = '/enrolments/organisation/check';

        if (!item && window.location.pathname !== checkUrl) {
          window.location.href = checkUrl;
          return conf;
        }

        const storedValue: OrganisationContextData = item ? JSON.parse(item) : {};

        if (conf.headers && storedValue?.id) {
          conf.headers['X-Organisation-Id'] = storedValue.id;
        }
        return conf;
      } catch (error) {
        return conf;
      }
    },
    (error) => {
      return Promise.reject(error);
    },
  );
};
